// Generouted, changes to this file will be overridden
/* eslint-disable */

import { components, hooks, utils } from '@generouted/react-router/client';

export type Path =
  | `/`
  | `/admin`
  | `/admin/analytics`
  | `/admin/reservations`
  | `/admin/restaurants`
  | `/admin/settings`
  | `/admin/users`
  | `/admin/whatsapp`
  | `/app`
  | `/app/:entityId`
  | `/app/:entityId/blocked-times`
  | `/app/:entityId/calendar`
  | `/app/:entityId/commissions`
  | `/app/:entityId/customer-analysis`
  | `/app/:entityId/customer-detail/:customerId`
  | `/app/:entityId/customer-history`
  | `/app/:entityId/customer-notes`
  | `/app/:entityId/customers`
  | `/app/:entityId/daily-revenue`
  | `/app/:entityId/expenses`
  | `/app/:entityId/export-data`
  | `/app/:entityId/finances`
  | `/app/:entityId/financial-reports`
  | `/app/:entityId/history`
  | `/app/:entityId/loyalty-program`
  | `/app/:entityId/monthly-overview`
  | `/app/:entityId/new-customer`
  | `/app/:entityId/new-reservation`
  | `/app/:entityId/performance`
  | `/app/:entityId/profile`
  | `/app/:entityId/quick-actions`
  | `/app/:entityId/reports`
  | `/app/:entityId/revenue-distribution`
  | `/app/:entityId/salon-profile`
  | `/app/:entityId/service-analysis`
  | `/app/:entityId/service-categories`
  | `/app/:entityId/services-prices`
  | `/app/:entityId/settings`
  | `/app/:entityId/staff`
  | `/app/:entityId/staff-performance`
  | `/app/:entityId/staff-schedule`
  | `/app/:entityId/system-settings`
  | `/app/:entityId/today`
  | `/app/:entityId/vacations`
  | `/app/:entityId/waiting-list`
  | `/app/:entityId/working-hours`
  | `/app/:entityId/working-hours-settings`
  | `/login`
  | `/register`
  | `/site`
  | `/site/contact`
  | `/site/prices`;

export type Params = {
  '/app/:entityId': { entityId: string };
  '/app/:entityId/blocked-times': { entityId: string };
  '/app/:entityId/calendar': { entityId: string };
  '/app/:entityId/commissions': { entityId: string };
  '/app/:entityId/customer-analysis': { entityId: string };
  '/app/:entityId/customer-detail/:customerId': { entityId: string; customerId: string };
  '/app/:entityId/customer-history': { entityId: string };
  '/app/:entityId/customer-notes': { entityId: string };
  '/app/:entityId/customers': { entityId: string };
  '/app/:entityId/daily-revenue': { entityId: string };
  '/app/:entityId/expenses': { entityId: string };
  '/app/:entityId/export-data': { entityId: string };
  '/app/:entityId/finances': { entityId: string };
  '/app/:entityId/financial-reports': { entityId: string };
  '/app/:entityId/history': { entityId: string };
  '/app/:entityId/loyalty-program': { entityId: string };
  '/app/:entityId/monthly-overview': { entityId: string };
  '/app/:entityId/new-customer': { entityId: string };
  '/app/:entityId/new-reservation': { entityId: string };
  '/app/:entityId/performance': { entityId: string };
  '/app/:entityId/profile': { entityId: string };
  '/app/:entityId/quick-actions': { entityId: string };
  '/app/:entityId/reports': { entityId: string };
  '/app/:entityId/revenue-distribution': { entityId: string };
  '/app/:entityId/salon-profile': { entityId: string };
  '/app/:entityId/service-analysis': { entityId: string };
  '/app/:entityId/service-categories': { entityId: string };
  '/app/:entityId/services-prices': { entityId: string };
  '/app/:entityId/settings': { entityId: string };
  '/app/:entityId/staff': { entityId: string };
  '/app/:entityId/staff-performance': { entityId: string };
  '/app/:entityId/staff-schedule': { entityId: string };
  '/app/:entityId/system-settings': { entityId: string };
  '/app/:entityId/today': { entityId: string };
  '/app/:entityId/vacations': { entityId: string };
  '/app/:entityId/waiting-list': { entityId: string };
  '/app/:entityId/working-hours': { entityId: string };
  '/app/:entityId/working-hours-settings': { entityId: string };
};

export type ModalPath = never;

export const { Link, Navigate } = components<Path, Params>();
export const { useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>();
export const { redirect } = utils<Path, Params>();
